import { AxiosError } from 'axios';

import { USERS_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { CreateNoteRequest, Note } from '@/types/note.type';
import { ApiResponse } from '@/types/response.type';

interface CreateUserNoteRequest {
  payload: CreateNoteRequest;
  userId: string;
}

const createNote = async (
  params: CreateUserNoteRequest
): Promise<ApiResponse<Note>> => {
  try {
    const { payload, userId } = params;

    // For direct frontend uploads, we send the complete payload with attachment URLs
    const response = await apiManager.post(
      `${USERS_API_URL}/${userId}/notes`,
      payload,
      {
        headers: { 'Content-Type': 'application/json' },
      }
    );

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};

export default createNote;
